export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/contact-usw-0065e263b16d0ee4fb900889e68973bf.webp";